import { isNil } from 'lodash'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { Alert } from 'features/alerts/types/alert'
import { AdUnitDTO } from 'features/inventory/api/types/adUnitDTO'
import { DomainDTO } from 'features/inventory/api/types/domainDTO'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { AdUnit } from 'features/inventory/types/adUnit'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { gql } from 'providers/tanstack-query/utils'

type Data = {
  node: null | {
    domain: Pick<DomainDTO, 'alerts'>
  }
}
type Variables = {
  id: AdUnitDTO['id']
}

export const useGetFreshAdUnitDomainAlerts = ({
  adUnitId,
}: {
  adUnitId?: AdUnit['id']
}): Alert<DomainAlert>[] => {
  const { data } = useQuery<Variables, Data, Alert<DomainAlert>[]>({
    options: {
      enabled: adUnitId !== undefined,
      refetchInterval: DEFAULT_REFETCH_INTERVAL,
      select: ({ node }: Data): Alert<DomainAlert>[] => {
        if (isNil(node)) {
          return []
        }

        return alertsFromDTO<DomainAlert>(node.domain.alerts)
      },
    },
    query: gql`
      query getFreshAdUnitDomainAlerts($id: ID!) {
        node(id: $id) {
          ... on AdUnit {
            domain {
              alerts {
                name
                description
              }
            }
          }
        }
      }
    `,
    variables: { id: adUnitId! },
  })

  return data ?? []
}
